import { setAuthState } from './auth';

export const SUBSCRIPTION_CANCELLATION_V2 = 'subscription-cancellation-v2';

// Gates the reason-branched cancellation flow. The cancel endpoint enforces a matching
// contract behind the same flag (a single enum reason while it is on, the legacy
// multi-select array while it is off), so the two must be read from the same source.
export const isSubscriptionCancellationV2Enabled = () => {
	const { userHaveAccessTo } = setAuthState();

	return userHaveAccessTo(SUBSCRIPTION_CANCELLATION_V2);
};
